var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdviceNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1718_2020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 24.5C10.5 25.1417 11.025 25.6667 11.6666 25.6667H16.3333C16.975 25.6667 17.5 25.1417 17.5 24.5V23.3334H10.5V24.5ZM14 2.33337C9.49665 2.33337 5.83331 5.99671 5.83331 10.5C5.83331 13.2767 7.22165 15.715 9.33331 17.1967V19.8334C9.33331 20.475 9.85831 21 10.5 21H17.5C18.1416 21 18.6666 20.475 18.6666 19.8334V17.1967C20.7783 15.715 22.1666 13.2767 22.1666 10.5C22.1666 5.99671 18.5033 2.33337 14 2.33337ZM17.325 15.2834L16.3333 15.9834V18.6667H11.6666V15.9834L10.675 15.2834C9.09998 14.1867 8.16665 12.4017 8.16665 10.5C8.16665 7.28004 10.78 4.66671 14 4.66671C17.22 4.66671 19.8333 7.28004 19.8333 10.5C19.8333 12.4017 18.9 14.1867 17.325 15.2834Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1718_2020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdviceNoteIcon);
export default __webpack_public_path__ + "static/media/advice-note-icon.0b708bc09e9469e84a32692cc5eb1240.svg";
export { ForwardRef as ReactComponent };